import { render, staticRenderFns } from "./InspirationTabelItem.vue?vue&type=template&id=3a59a4ff&"
import script from "./InspirationTabelItem.vue?vue&type=script&lang=js&"
export * from "./InspirationTabelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports